import * as dynamicModals from '~/constants/dynamicModals';
var globalConstants = {
  dynamicModals: dynamicModals
};
export default (function (_, inject) {
  inject('constants', globalConstants);
});